import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  TextField,
  MenuItem,
  Select,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import CloseIcon from "@mui/icons-material/Close";

const AddCoupon = ({
  openAddCoupon,
  handleAdd,
  classes,
  getAllCoupons,
  handleMessage,
  handleSuccessPop,
  handleErrorPop,
}) => {
  const [isAffiliate, setIsAffiliate] = useState("no");
  const [affiliateList, setAffiliateList] = useState([]);

  const validationSchema = yup.object({
    code: yup.string().required("Coupon code is required").trim(),
    type: yup.string().required("Discount type is required"),
    status: yup.string().required("Status is required"),
    value: yup
      .number()
      .required("Discount value is required")
      .min(1, "Value must be at least 1"),
    isAffiliate: yup.string().required("Please select affiliate status"),
    affiliateType: yup.string().when("isAffiliate", {
      is: "yes",
      then: (schema) => schema.required("Affiliate type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      type: "percentage",
      status: "1",
      value: "",
      isAffiliate: "no",
      affiliateType: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);

      try {
        const accessToken = localStorage.getItem("accessToken");
        const response = await axios.post(
          `${API_URL}/create/discount`,
          {
            code:formik.values.code,
            type:formik.values.type,
            value:formik.values.value,
            status:formik.values.status,
            affilliateId:isAffiliate=="no"?null:formik.values.affiliateType
          },
          {
            headers: {
              "x-access-token": accessToken,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 201 || response.status === 200) {
          handleMessage(response.data.message);
          getAllCoupons(0);
          handleAdd();
          handleSuccessPop();
          resetForm();
          setIsAffiliate("no");
        }
      } catch (error) {
        if (error.response) {
          handleMessage(error.response.data.message || "Error");
          handleErrorPop();
        } else {
          alert("Network error");
        }
      }
    },
  });
  const fetchAllAffiliates = async () => {
    try {
      const response = await axios.get(`${API_URL}/get/all/affiliate`);
    
      if (response.data.status) {
        setAffiliateList(response.data.affiliates);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllAffiliates();
  }, []);


  return (
    <Dialog
      open={openAddCoupon}
      onClose={handleAdd}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          width: "500px",
          border: "2px solid #7C1386",
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="ml-1 roititle">Add Coupon</span>
        <IconButton
          onClick={handleAdd}
          disableRipple
          sx={{ color: "#000", p: 1, background: "rgb(0 0 0 / 4%)" }}
        >
          <CloseIcon sx={{ fontSize: "1.3rem" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Code */}
            <Box>
              <Typography sx={{ fontWeight: 600, color: "#7C1386" }}>
                Code <sup>*</sup>
              </Typography>
              <TextField
                fullWidth
                name="code"
                className={classes.bin1}
                value={formik.values.code}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter coupon code"
                variant="standard"
              />
              {formik.touched.code && formik.errors.code && (
                <Typography className={classes.error}>
                  {formik.errors.code}
                </Typography>
              )}
            </Box>

            {/* Discount Type */}
            <Box>
              <Typography sx={{ fontWeight: 600, color: "#7C1386" }}>
                Discount Type <sup>*</sup>
              </Typography>
              <Select
                fullWidth
                name="type"
                className={classes.bin1}
                value={formik.values.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="standard"
                sx={{
                  padding: "5px 10px",
                  "&::before": { borderBottom: "none !important" },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: "none !important",
                  },
                  "&::after": { borderBottom: "none !important" },
                }}
              >
                <MenuItem value="percentage">Percentage</MenuItem>
                <MenuItem value="amount">Amount</MenuItem>
              </Select>
              {formik.touched.type && formik.errors.type && (
                <Typography className={classes.error}>
                  {formik.errors.type}
                </Typography>
              )}
            </Box>

            {/* Discount Value */}
            <Box>
              <Typography sx={{ fontWeight: 600, color: "#7C1386" }}>
                {formik.values.type === "percentage"
                  ? "Discount (%)"
                  : "Discount Amount ($)"}{" "}
                <sup>*</sup>
              </Typography>
              <TextField
                fullWidth
                name="value"
                type="number"
                className={classes.bin1}
                value={formik.values.value}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter discount value"
                variant="standard"
              />
              {formik.touched.value && formik.errors.value && (
                <Typography className={classes.error}>
                  {formik.errors.value}
                </Typography>
              )}
            </Box>

            <Box>
              <FormControl component="fieldset">
                <FormLabel sx={{ fontWeight: 600, color: "#7C1386" }}>
                  Is this for affiliates' users?
                </FormLabel>
                <RadioGroup
                  row
                  name="isAffiliate"
                  value={formik.values.isAffiliate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setIsAffiliate(value);
                    formik.setFieldValue("isAffiliate", value);
                    formik.setTouched({
                      ...formik.touched,
                      isAffiliate: true,
                    });
                    if (value === "no") {
                      formik.setFieldValue("affiliateType", "");
                    }
                  }}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
              {formik.touched.isAffiliate && formik.errors.isAffiliate && (
                <Typography className={classes.error}>
                  {formik.errors.isAffiliate}
                </Typography>
              )}
            </Box>
          </Box>
          {formik.values.isAffiliate === "yes" && (
            <Box>
              <Typography sx={{ fontWeight: 600, color: "#7C1386" }}>
                Select Affiliate <sup>*</sup>
              </Typography>
              <Select
                fullWidth
                name="affiliateType"
                className={classes.bin1}
                value={formik.values.affiliateType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="standard"
                sx={{
                  padding: "5px 10px",
                  "&::before": { borderBottom: "none !important" },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: "none !important",
                  },
                  "&::after": { borderBottom: "none !important" },
                }}
              >
              {
                affiliateList?.map((item,i)=>(

                <MenuItem key={i} value={item?.id}>{item.firstName} {item.lastName}</MenuItem>
                ))
              }
             
              </Select>
              {formik.touched.affiliateType && formik.errors.affiliateType && (
                <Typography className={classes.error}>
                  {formik.errors.affiliateType}
                </Typography>
              )}
            </Box>
          )}

          <Box className={classes.btns} mt={3}>
            <Button
              type="submit"
              variant="contained"
              sx={{ color: "#fff !important" }}
              disabled={!formik.isValid}
            >
              Submit
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddCoupon;
